import { ButtonHTMLAttributes } from 'react';

import './style.css';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    text: string;
} 

const Button = ({ text, ...rest }: ButtonProps) => {
    return (
        <button className="btn" {...rest}>{text}</button>
    );
};

export default Button;